import { render, staticRenderFns } from "./address.vue?vue&type=template&id=1d8ba574&scoped=true&"
import script from "./address.vue?vue&type=script&lang=js&"
export * from "./address.vue?vue&type=script&lang=js&"
import style0 from "./address.vue?vue&type=style&index=0&id=1d8ba574&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d8ba574",
  null
  
)

export default component.exports